<div class="row g-0 gallery-us-card">
<!-- Close button -->
  <button 
    type="button" 
    class="btn-close position-absolute m-3" 
    aria-label="Close"
    (click)="closeCard()">
  </button>
 
  <div class="col-md-4 p-4 gallery-us-bg d-flex flex-column justify-content-start">
    <h2 class="text-orange fs-4 fw-bold mb-3">Gallery</h2>
    <p class="text-gray small mb-0">
      We're proud to share that Kalpita Technologies has been featured among the best outsourcing 
      service providers, a recognition that highlights our commitment to delivering exceptional service,
      innovation, and value to our clients worldwide.
    </p>
  </div>
  
  <div class="col-md-8 p-4 bg-white">
    <h3>Gallery</h3>
    <ul class="list-unstyled mb-0">
      <li><a routerLink="/gallery/life-at-kalpita" class="dropdown-item" (click)="closeCard()">Life at Kalpita</a></li>
      <li><a routerLink="/gallery/learn-with-kalpita" class="dropdown-item" (click)="closeCard()">Learn With Kalpita</a></li>
      <!-- PENDING: Testimonials will be moved/implemented under About Us once the
           page is fully designed and ready. Do NOT re-enable this link until then -
           the route is withdrawn and /gallery/kalpita-testimonials returns 404. -->
      <!-- <li><a routerLink="/gallery/kalpita-testimonials" class="dropdown-item" (click)="closeCard()">Testimonials</a></li> -->
    </ul>
  </div>
</div>